var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#221D23",
    fillOpacity: 0.35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2343 17.9999C36.2343 19.7949 34.7793 21.2501 32.9843 21.2501C31.1893 21.2501 29.7344 19.7949 29.7344 17.9999C29.7344 16.2051 31.1893 14.75 32.9843 14.75C34.7793 14.75 36.2343 16.2051 36.2343 17.9999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9843 22.0001C30.7783 22.0001 28.9844 20.206 28.9844 17.9999C28.9844 15.7941 30.7783 14 32.9843 14C35.1904 14 36.9843 15.7941 36.9843 17.9999C36.9843 20.206 35.1904 22.0001 32.9843 22.0001ZM32.9843 15.5C31.6053 15.5 30.4844 16.6221 30.4844 17.9999C30.4844 19.378 31.6053 20.5001 32.9843 20.5001C34.3633 20.5001 35.4843 19.378 35.4843 17.9999C35.4843 16.6221 34.3633 15.5 32.9843 15.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2343 34.0001C36.2343 35.7949 34.7793 37.2501 32.9843 37.2501C31.1893 37.2501 29.7344 35.7949 29.7344 34.0001C29.7344 32.2051 31.1893 30.75 32.9843 30.75C34.7793 30.75 36.2343 32.2051 36.2343 34.0001Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9843 38.0001C30.7783 38.0001 28.9844 36.206 28.9844 34.0001C28.9844 31.7941 30.7783 30 32.9843 30C35.1904 30 36.9843 31.7941 36.9843 34.0001C36.9843 36.206 35.1904 38.0001 32.9843 38.0001ZM32.9843 31.5C31.6053 31.5 30.4844 32.6221 30.4844 34.0001C30.4844 35.378 31.6053 36.5001 32.9843 36.5001C34.3633 36.5001 35.4843 35.378 35.4843 34.0001C35.4843 32.6221 34.3633 31.5 32.9843 31.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2344 25.9999C22.2344 27.7949 20.7793 29.2499 18.9843 29.2499C17.1895 29.2499 15.7344 27.7949 15.7344 25.9999C15.7344 24.205 17.1895 22.75 18.9843 22.75C20.7793 22.75 22.2344 24.205 22.2344 25.9999Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9843 29.9999C16.7784 29.9999 14.9844 28.206 14.9844 25.9999C14.9844 23.7939 16.7784 22 18.9843 22C21.1904 22 22.9844 23.7939 22.9844 25.9999C22.9844 28.206 21.1904 29.9999 18.9843 29.9999ZM18.9843 23.5C17.6053 23.5 16.4844 24.6219 16.4844 25.9999C16.4844 27.378 17.6053 28.4999 18.9843 28.4999C20.3635 28.4999 21.4844 27.378 21.4844 25.9999C21.4844 24.6219 20.3635 23.5 18.9843 23.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3455 25.5178C20.9974 25.5178 20.6594 25.3367 20.4754 25.0128C20.2024 24.5338 20.3704 23.9228 20.8494 23.6487L30.1283 18.3588C30.6073 18.0838 31.2183 18.2518 31.4925 18.7327C31.7655 19.2117 31.5974 19.8227 31.1184 20.0968L21.8393 25.3867C21.6833 25.4757 21.5134 25.5178 21.3455 25.5178Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6226 33.7686C30.4545 33.7686 30.2846 33.7265 30.1286 33.6375L20.8496 28.3476C20.3705 28.0746 20.2026 27.4636 20.4757 26.9835C20.7476 26.5035 21.3595 26.3345 21.8396 26.6096L31.1186 31.8995C31.5976 32.1725 31.7656 32.7835 31.4925 33.2636C31.3076 33.5875 30.9696 33.7686 30.6226 33.7686Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.7b85bfec6aef7f99e0bc517d4371dae8.svg";
export { ForwardRef as ReactComponent };